module.exports = __webpack_public_path__ + "site-12.jpg?6afff51e49423fc810c6c812e1af05dd";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/portfolio/site-12.jpg
 ** module id = 97
 ** module chunks = 0
 **/